import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/planejamento/'

class ConsultaPlanoAnualContratacoesService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio : '',
        }

        return this.conex.post(urlConsultaDiarias + 'consultaElaboracaoPlanejamento/', JSON.stringify(data))
    }
}

export default ConsultaPlanoAnualContratacoesService
